import { render } from "./CipherbcCoin.vue?vue&type=template&id=5fe97e76"
import script from "./CipherbcCoin.vue?vue&type=script&lang=js"
export * from "./CipherbcCoin.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__